'use client';

import Image from 'next/image';
import type { ReactNode } from 'react';

import Navbar from '@/components/navbar';

interface MainProps {
  meta?: ReactNode;
  children: ReactNode;
}

function Header() {
  return (
    <header className="h-[20vh] border-b border-gray-300 bg-gradient-to-b from-green-600 to-gray-100">
      <div className="absolute left-0 top-0 z-0 h-[20vh] min-w-full ">
        <Image
          src="/assets/images/home-page/top-bg.svg"
          alt="Background"
          fill
          priority
          sizes="100vw"
          style={{ objectFit: 'cover' }}
        />
      </div>
      <div className="absolute left-0 top-0 z-10 w-full px-16 py-8 text-white">
        <Navbar />
      </div>
    </header>
  );
}

export function Main({ meta, children }: MainProps) {
  return (
    <div className="w-full bg-gray-200 text-gray-700 antialiased">
      {meta}

      <div>
        <Header />
        {/* <header className="border-b border-gray-300">
           <div className="pb-8 pt-16">
            <h1 className="text-3xl font-bold text-gray-900">
              {AppConfig.title}
            </h1>
            <h2 className="text-xl">{AppConfig.description}</h2>
          </div>

          <Navbar />
        </header> */}

        <main className="content py-5 text-xl">{children}</main>
      </div>
    </div>
  );
}
